import React from 'react'
import PartTitle from '../HomePartTitle/index'
import './style.scss'

interface PartProps {
  title?: string
  id?: string
}

const Part: React.FC<PartProps> = ({ title, id, children }) => {
  return (
    <div className="home-part" id={id}>
      <div className="width-container">
        {title && <PartTitle>{title}</PartTitle>}
        <div className="part-content">{children}</div>
      </div>
    </div>
  )
}

export default Part
